import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, rem, Spinner, StyleProps } from '@bonusly/design-system';

type SpacedSpinnerProps = StyleProps;

export const SpacedSpinner: FC<SpacedSpinnerProps> = (props) => {
	const { t } = useTranslation('common');

	return (
		<Flex justifyContent="center" my={rem(44)} {...props}>
			<Spinner color="gray.400" data-testid="spinner" label={t('loading') ?? ''} size="lg" />
		</Flex>
	);
};
